module.exports = "/_next/static/images/10f46e1d9619e5e4fe8b741efe4ffaa2-mockup-transfer@1.5x.jpg.webp";